<template>
  <div
    class="form-no-messages"
    style="position:relative"
  >
    <ProductionReceipt />
  </div>
</template>
<script>
import ProductionReceipt from './ProductionReceipt.vue'
// import AppLib from '../../share/AppLib'
// import ConstDef from '../../../../MesSmartVue/src/share/ConstDef'
// import HttpService from '../../share/service/HttpService'
// import AesCrypto from '../../share/service/AesCrypto'

export default {
  name: 'EmptView',
  components: {
    ProductionReceipt
  },
  data: function () {
    return {
      isLoading: false,
      userInfo: null
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
